//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const formatDate = (val) => {
    return val ? val.replace(/\-/g, '.') : ''
}
const getDateTime = (val) => {
    if (val) {
        return new Date(val.replace(/\-/g, '/')).getTime()
    }
    return 0
}
const getTimeline = () => ([
    {
        class: '',
        time_points: ['presell_date'],
        getText: (house_time) => house_time.presell_date,
        tx: '',
        title: '取证',
        getTip: () => {
            return {
                tx: '楼盘取得预/现售许可证，可以进行销售；'
            }
        }
    },
    {
        class: '',
        time_points: ['ln_register_start_time', 'ln_register_end_time'],
        getText: (house_time) => house_time.ln_register,
        tx: '',
        title: '登记',
        getTip: (house) => {
            if (house.zone_level === 3) {
                return {
                    tx: '请前往售楼部现场登记；'
                }
            }
            return {
                tx: '请前往成都市住房和城乡建设局官网进行登记，查看报名指引 >>',
                link: '/reg_step/main'
            }
        }
    },
    {
        class: '',
        time_points: ['ln_verify_start_date', 'ln_verify_end_date'],
        getText: (house_time) => house_time.ln_verify,
        tx: '',
        title: '初核',
        getTip: (house, { attachment_urls }) => {
            if (attachment_urls.rule) {
                return {
                    tx: '资料缴纳中，点击查看提交资料地址及注意事项 >>',
                    download: attachment_urls.rule
                }
            }
            return null
        }
    },
    {
        class: '',
        time_points: ['primary_publicity_start_date', 'primary_publicity_end_date'],
        getText: (house_time) => house_time.primary_publicity,
        tx: '',
        title: '初核公示',
        checkShow: ({ primary_publicity_start_date, primary_publicity_end_date }) => {
            return primary_publicity_start_date || primary_publicity_end_date
        },
        getTip: (house, current_house) => {
        }
    },
    {
        class: '',
        time_points: ['visit_apartment_start_date', 'visit_apartment_end_date'],
        getText: (house_time) => house_time.visit_apartment,
        tx: '',
        title: '看房',
        checkShow: ({ visit_apartment_start_date, visit_apartment_end_date }) => {
            return visit_apartment_start_date || visit_apartment_end_date
        },
        getTip: (house, current_house) => {
            return null
        }
    },
    {

        class: '',
        time_points: ['ln_date'],
        getText: (house_time) => {
            return (house_time.ln_date || house_time.ln_time_desc) ?
                `${house_time.ln_date} ${house_time.ln_time_desc || ''}` : '待定'
        },
        tx: '',
        title: '摇号',
        checkShow: ({ ln_mode }) => {
            return ln_mode !== '开发商自行组织有序选房'
        },
        getTip: () => {
            return null
        }
    },
    {
        class: '',
        time_points: ['ln_bulletin_start_date', 'ln_bulletin_end_date'],
        getText: (house_time) => house_time.ln_bulletin,
        tx: '',
        title: '复核',
        checkShow: ({ ln_bulletin_start_date, ln_bulletin_end_date }) => {
            return ln_bulletin_start_date || ln_bulletin_end_date
        },
        getTip: (house, current_house) => {
            return null
        }
    },
    {
        class: '',
        time_points: ['review_publicity_start_date', 'review_publicity_end_date'],
        getText: (house_time) => house_time.review_publicity,
        tx: '',
        title: '复核公示',
        checkShow: ({ review_publicity_start_date, review_publicity_end_date }) => {
            return review_publicity_start_date || review_publicity_end_date
        },
        getTip: (house, current_house) => {
            if (current_house.lrd_status === 'lrd_completed') {
                const link = `/result/main?building_id=${house.id || ''}&house_id=${current_house.id || ''}&name=${house.name}&type=reg`
                return {
                    tx: '复核结果已出，点击查看复核名单 >>',
                    link
                }
            }
            return null
        }
    },
    {
        class: 'large',
        time_points: ['apartment_selection_start_date', 'apartment_selection_end_date'],
        getText: (house_time) => house_time.apartment_selection,
        tx: '',
        title: '开盘选房',
        getTip: (house, { ln_mode }) => {
            if (ln_mode === '公证摇号') {
                return {
                    tx: '放弃选房将会对购房资格产生影响，点击查看具体影响 >>',
                    link: `/pages/personal_package/questions/detail/main?id=2841`
                }
            }
            return null
        }
    }
])
export default {
    name: 'TIMELINE',
    data () {
        return {
            timeline: [],
            house_time: {},
            tip: null
        }
    },
    mounted () {
        this.handleData(this.current_house)
    },
    computed: {
        selected_id () {
            let selected_index = -1
            this.timeline && this.timeline.length && this.timeline.some((item, i) => {
                if (item.selected) {
                    selected_index = i
                }
            })
            if (selected_index > -1) {
                if (selected_index > 0 && this.timeline.length - selected_index > 3) {
                    return `item-${selected_index - 1}`
                }
                return `item-${selected_index}`
            }
            return ''
        }
    },
    watch: {
        current_house (latest) {
            this.handleData(latest)
        }
    },
    methods: {
        handleData (current_house) {
            const house_time = {}
            const YEAR_MONTH_DAY_FORMAT = [
                'presell_date'
            ]
            const MONTH_DAY_FORMAT = [
                'ln_register_start_date',
                'ln_register_end_date',
                'primary_publicity_start_date',
                'primary_publicity_end_date',
                'visit_apartment_start_date',
                'visit_apartment_end_date',
                'ln_bulletin_start_date',
                'ln_bulletin_end_date',
                'apartment_selection_start_date',
                'apartment_selection_end_date',
                'ln_verify_start_date',
                'ln_verify_end_date',
                'review_publicity_start_date',
                'review_publicity_end_date',
                'ln_date'
            ]
            YEAR_MONTH_DAY_FORMAT.forEach((key) => {
                house_time[key] = formatDate(current_house[key])
            })
            MONTH_DAY_FORMAT.forEach((key) => {
                house_time[key] = current_house[key] ? formatDate(current_house[key].substring(5)) : ''
            })
            const segemnt_time = ['ln_register', 'ln_verify', 'primary_publicity', 'review_publicity', 'visit_apartment', 'ln_bulletin', 'apartment_selection']
            segemnt_time.forEach((key) => {
                const start = house_time[`${key}_start_date`]
                const end = house_time[`${key}_end_date`]
                if (!start && !end) {
                    house_time[key] = '待定'
                } else if (!start || !end || start === end) {
                    house_time[key] = `${start || end}`
                } else {
                    house_time[key] = `${start}-${end}`
                }
            })
            house_time.ln_time_desc = current_house.ln_time_desc
            this.house_time = house_time
            this.handleTimeline(current_house)
        },
        handleTimeline (current_house) {
            try {
                let timeline  = getTimeline()
                if (current_house.stages && current_house.stages.length) {
                    timeline = current_house.stages.map((title) => {
                        let item
                        timeline.some((time_point) => {
                            if (time_point.title === title) {
                                item = time_point
                                item.checkShow = () => true
                                return true
                            }
                        })
                        return item
                    })
                }
                const valid_time = []
                let is_active = false
                const date_time = current_house.current_time ? getDateTime(current_house.current_time) : ''
                for (let i = timeline.length - 1; i >= 0; i--) {
                    let item = timeline[i]
                    item.tx = item.getText(this.house_time)
                    if (item.tx) {
                        valid_time.push(item.tx)
                    } else if (!valid_time.tx) {
                        item.tx = '待定'
                    }
                    if (item.checkShow && typeof item.checkShow === 'function') {
                        item.content_hide = !item.checkShow(current_house)
                    }
                    item.tip = item.getTip(this.house, current_house)
                    // 如果后置时间已到，则前置时间无需计算
                    const active = is_active || item.time_points.some((name) => {
                        return current_house[name] && date_time >= getDateTime(current_house[name])
                    })
                    const is_doing = false
                    const time_points = item.time_points.map((key) => {
                        return current_house[key] ? current_house[key].substr(0, 10) : ''
                    })
                    if (time_points.length === 1) {
                        is_doing = date_time === getDateTime(time_points[0])
                    } else if (item.time_points.length === 2) {
                        const start = time_points[0]
                        const end = time_points[1]
                        is_doing = date_time >= getDateTime(start)
                            &&
                            date_time <= getDateTime(end)
                    }
                    if (active) {
                        item.class += ' active'
                        if (is_doing) {
                            item.doing = true
                            this.tip = item.tip
                            console.error(this.tip)
                        }
                    }
                    is_active = active
                }
                timeline.some((item) => {
                    if (item.doing) {
                        item.selected = true
                        return true
                    }
                })
                this.timeline = timeline.filter(({ content_hide }) => !content_hide)
            } catch  (err) {
                console.error(err)
            }
        },
        tapPoint (index) {
            this.tip = this.timeline[index].tip
            this.timeline.forEach((item, i) => {
                this.$set(this.timeline, i, {
                    ...item,
                    selected: i === index
                })
            })
        },
        tapTip (e) {
            const { link, download } = e.target.dataset
            if (link) {
                 this.$router.push({
                    path: link
                })
            }
            if (download) {
                this.download(download)
            }
        },
        download (url) {
            window.location.href = url
        },
    },
    props: {
        house: {
            type: Object,
            default () {
                return {}
            }
        },
        current_house: {
            type: Object,
            default () {
                return {}
            }
        }
    }
}
